import React from 'react'
import { Card, CardHeader, Tooltip, CardBody, Loader, Flex, Button, EditIcon, Dialog, Form, FormInput, Text,FormDropdown,CloseIcon,TrashCanIcon,Dialog as FluentDialog } from '@fluentui/react-northstar';
import { Grid as KendoGrid, GridColumn as Column } from "@progress/kendo-react-grid";
import GridGlobalSearch from '../../../../shared/appcomponents/data-grid-search';
import { CellNumberedStringList, CellAccessIcon, CellHealthStatus, CellServerGraphLabel, CellDateTime, CellServiceName, CellInstanceOverviewLabel, CellOpenAlerts, CellColTitle, CellTenantedAlerts,CellInstanceNALabel } from '../../../../shared/appcomponents/custom-grid-cells';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MonitoringService from '../../../../services/monitoringservice';
import { INCIDENTLEVELS, OPERATIONSTATUS } from '../../../../shared/appcomponents/enums';
import CustomQueryFilter from '../../../../shared/appcomponents/custom-query-filter';
import { process } from "@progress/kendo-data-query";
import { getRouteFromLocalStorage, WindowContext } from "../../../../shared/contexts/Context";
import { RenderTooltipCell } from "../../../../shared/appcomponents/TooltipWithCopy"
import { DialogActionsBar } from "@progress/kendo-react-dialogs";

const ServiceDetail = (props) => {
  const { id, type } = useParams();
  const [details, setDetails] = React.useState(null);
  const [detailTable, setDetailTable] = React.useState(null);
  const [serviceState, setserviceState] = React.useState(null);
  const [isLoaded, setLoaded] = React.useState(false);
  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const routeChange = (path) => {
    navigate(path);
  }
  const [dataState, setDataState] = React.useState({
    sort: [
      {
        field: "ServiceName",
        dir: "asc",
      },
    ],
    take: 10,
    skip: 0,
  });
  const [editMode, setEditMode] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [serviceData, setserviceData] = React.useState(null);
  const [showActionColumn, setshowActionColumn] = React.useState(false);
  const [instances, setInstances] = React.useState(null);
  const [InsNotMapped, setInsNotMapped] = React.useState(null);
  const [deleteServiceObj, setDeleteServiceObj] = React.useState(null);
  const [openDeleteConfirmationDialog, setDeleteConfirmationDialog] = React.useState(false);
  const [serviceInstance, setServiceInstance] = React.useState("0");
  
  const updateDetailData = (response) => {
    setDetails(response);
    setInsNotMapped(response.Warning);    
    response.Table.forEach((t) => {
    });
    setDetailTable(response.Table);
  }

  React.useEffect(() => {
    props.acquireToken((token) => {
      setLoaded(false);
      let _alarmType = searchParams.get('state');
      let _state = INCIDENTLEVELS[_alarmType];
      if (_state == null) {
        _state = -1;
      }
      setserviceState(_state);
      let _params = {
        instanceId: id ? id : -1,
        incidentLevelId: _state,
        appliedFilters: type
          ? id
            ? [`InstanceId IN (${id})`, `ServiceTypeId IN (${type})`]
            : []
          : id
            ? [`InstanceId IN (${id})`]
            : [],
      };
      if (token) {
        MonitoringService.GetServiceMonitoringDetails(token, _params).then((response) => {
          if (response && response.status == 200) {
            response = response.data;
            setInstances(response?.Instances?.map((m) => ({header: m.Value, value: m.Key})));
            updateDetailData(response);
          }
          else if (response && response.status == 401) {
            props.viewStatus.InformChildPageStatus(response.status);
          }
          else {
            props.viewStatus.InformChildPageStatus(500);
          }

          setLoaded(true);
        });
      }
    });
  }, [id, type,InsNotMapped]);

  React.useEffect(() => {
    let _alarmType = searchParams.get('state');
    let _state = INCIDENTLEVELS[_alarmType];
    if (_state == null) {
      _state = -1;
    }
    setDataState({
      ...dataState,
      skip: 0 // Reset to first page
    });
    setserviceState(_state);
    if(_state == "1")
    {
    setshowActionColumn(true);
    }
    else
    {
      setshowActionColumn(false);
    }
  }, [searchParams]);

  const handleFilterUpdate = (appliedFilters) => {
    setLoaded(false);
    setDetails(null);
    setDetailTable(null);
    props.acquireToken((token) => {
      let _params = {
        instanceId: id ? id : -1,
        incidentLevelId: serviceState,
        appliedFilters: appliedFilters
      }
      if (token) {
        MonitoringService.GetServiceMonitoringDetails(token, _params).then((response) => {
          if (response && response.status == 200) {
            response = response.data;
            updateDetailData(response);
          }
          else if (response && response.status == 401) {
            props.viewStatus.InformChildPageStatus(response.status);
          }
          else {
            props.viewStatus.InformChildPageStatus(500);
          }

          setLoaded(true);
        });
      }
    })
  }

  const filterGridData = (value) => {
    let filter = {
      logic: 'or',
      filters: [
        { field: 'ServiceName', operator: 'contains', value: value },
        { field: 'ServiceDisplayName', operator: 'contains', value: value },
        { field: 'DCName', operator: 'contains', value: value },
        { field: 'InstanceName', operator: 'contains', value: value },
        { field: 'Platform', operator: 'contains', value: value },
      ],
    };
    setDataState({ ...dataState, filter: filter });
  };

  const expandChange = (event) => {
    let newData = detailTable.map((item) => {
      if (item.ServiceId === event.dataItem.ServiceId) {
        item.expanded = !event.dataItem.expanded;
      }
      return item;
    });
    setDetailTable(newData);
  };
  
  const CellOpenAlertsCol = (prop) => {
    return (
      <CellOpenAlerts {...prop} acquireToken={props.acquireToken} />
    );
  }

  const CellTenantedAlertsCol = (prop) => {
    return (
      <CellTenantedAlerts {...prop} acquireToken={props.acquireToken} />
    );
  }

  const ActionIconServices = (props) => {
    return (
      <td style={{ textAlign: "center" }}>
        <Button 
          className="mr-3" 
          styles={{ height: 'auto' }} 
          iconOnly 
          size="small" 
          icon={<EditIcon />} 
          text
          onClick={() => handleAddEditClickOpen(props.dataItem, true)}
        />
        <Button
                  styles={{ height: "auto" }}
                  iconOnly
                  size="small"
                  icon={<TrashCanIcon />}
                  text
                  onClick={() => {
                    setDeleteServiceObj(props.dataItem);
                    setserviceData({ ...serviceData, ServiceDisplayName: props.dataItem.ServiceDisplayName, DCName: props.dataItem.DCName });
                    setDeleteConfirmationDialog(true);
                  }}
                />
      </td>
    );
  };

  const removeData = () => {
    if (deleteServiceObj != null) {
      props.acquireToken((token) => {  
				if (token) {
					
						MonitoringService.DeleteService(token,serviceData).then((response) => {
							if (response && response.data == '-1') {
								props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Failed);
							} 
							else if(response && response.status==200){
                response=response.data;
                setInsNotMapped(response);
								//props.acquireToken(authSuccessCallback);
								props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
							} 
              
             setDialogOpen(false);
             //setInsMapped(true);
             //update dt
       /*    
      setLoaded(false);
      let _alarmType = searchParams.get('state');
      let _state = INCIDENTLEVELS[_alarmType];
      if (_state == null) {
        _state = -1;
      }
      setserviceState(_state);
      let _params = {
        instanceId: id ? id : -1,
        incidentLevelId: _state,
        appliedFilters: type
          ? id
            ? [`InstanceId IN (${id})`, `ServiceTypeId IN (${type})`]
            : []
          : id
            ? [`InstanceId IN (${id})`]
            : [],
      };
      if (token) {
        MonitoringService.GetServiceMonitoringDetails(token, _params).then((response) => {
          if (response && response.status == 200) {
            response = response.data;
            setInstances(response?.Instances?.map((m) => ({header: m.Value, value: m.Key})));
            updateDetailData(response);
          }
          else if (response && response.status == 401) {
            props.viewStatus.InformChildPageStatus(response.status);
          }
          else {
            props.viewStatus.InformChildPageStatus(500);
          }

          setLoaded(true);
        });
      }
       */




						});
					
						
					
					
				}      
				//setVisible(false);
				//setEditMode(false);
				//setIsValid(false);
			});
    }
    setDeleteConfirmationDialog(false);
    setDeleteServiceObj(null);
  };

  const handleAddEditClickOpen = (dataItem, isEdit) => {
    setServiceInstance("0");  
    setDialogOpen(true);
    if (isEdit === true) {
      setserviceData(dataItem);
      setserviceData({ ...serviceData, ServiceDisplayName: dataItem.ServiceDisplayName, DCName: dataItem.DCName });
      setEditMode(true);
    } else {
      setserviceData(null);
    }
  };

  const handleAddEditClickClose = () => {
    setDialogOpen(false);
    setserviceData(null);
    setEditMode(false);
  };

  const handleInstanceChange = (alwaysNull, data) => {
    setserviceData({ ...serviceData, InstanceId: data.value.value, InstanceName: data.value.header });
    setServiceInstance(data.value.value);  
  };

  const addEditSubmitClickHandler = () => {
//let isValid = CheckForm();
		//if(isValid == true){

			props.acquireToken((token) => {  
				if (token) {
					  if(serviceData.InstanceId != null)
            {       setServiceInstance(serviceData.InstanceId)      

              MonitoringService.UpdateServiceInstance(token,serviceData).then((response) => {
							if (response && response.data == '-1') {
								props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Failed);
							} 
							else if(response && response.status==200){
                response=response.data;
                setInsNotMapped(response);
								//props.acquireToken(authSuccessCallback);
								props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
							} 
              
             setDialogOpen(false);             
             
						});   

            }
            else
            {
               //alert("Please select instance");
               setServiceInstance(null);
            }					
				}      
				//setVisible(false);
				//setEditMode(false);
				//setIsValid(false);
			});
  
		//}
  };

  return (
    <WindowContext.Consumer>
      {(context) => (
        <div className='fluid w-100'>
          <div className='row mb-3'>
            <div className='col-md-12'>
              <Card className='card-border bg-white card-hov pt-2 pb-2' fluid ghost elevated>
                <CardHeader className='mb-2'>
                  <div className='d-flex'>
                    <div className='f-size-20'>Service Detail</div>
                  </div>
                </CardHeader>
                <div className='row'>
                  <div className='col-md-3 mb-3'>
                    <Card
                      onClick={() => routeChange(`/dashboards/monitoring/service/detail${id ? '/' + id : ''}${type ? '/' + type : ''}`)}
                      className={`card-border bg-white br-0 pt-1 p-0 card-action ${serviceState == -1 ? 'selected' : ''}`} fluid ghost elevated>
                      <div className='w-100 text-center'>
                        <div className='f-size-15'>Total Services</div>
                        <div className='f-size-26'>{details ? details.Total : '-'}</div>
                      </div>
                    </Card>
                  </div>
                  <div className='col-md-3 mb-3'>
                    <Card
                      onClick={() => routeChange(`/dashboards/monitoring/service/detail${id ? '/' + id : ''}${type ? '/' + type : ''}?state=healthy`)}
                      className={`card-border bg-success br-0 pt-1 p-0 card-action ${serviceState == 0 ? 'selected' : ''}`} fluid ghost elevated>
                      <div className='w-100 text-center text-white'>
                        <div className='f-size-15'>Healthy</div>
                        <div className='f-size-26'>{details ? details.Healthy : '-'}</div>
                      </div>
                    </Card>
                  </div>
                  <div className='col-md-3 mb-3'>
                    <Card
                      onClick={() => routeChange(`/dashboards/monitoring/service/detail${id ? '/' + id : ''}${type ? '/' + type : ''}?state=warning`)}
                      className={`card-border bg-warning br-0 pt-1 p-0 card-action ${serviceState == 1 ? 'selected' : ''}`} fluid ghost elevated>
                      <div className='w-100 text-center text-white'>
                        <div className='f-size-15'>Warning - Instance Not Mapped</div>
                        <div className='f-size-26'>{details ? details.Warning : '-'}</div>
                      </div>
                    </Card>
                  </div>
                  <div className='col-md-3 mb-3'>
                    <Card
                      onClick={() => routeChange(`/dashboards/monitoring/service/detail${id ? '/' + id : ''}${type ? '/' + type : ''}?state=critical`)}
                      className={`card-border bg-danger br-0 pt-1 p-0 card-action ${serviceState == 2 ? 'selected' : ''}`} fluid ghost elevated>
                      <div className='w-100 text-center text-white'>
                        <div className='f-size-15'>Critical - Heartbeat</div>
                        <div className='f-size-26'>{details ? details.Critical : '-'}</div>
                      </div>
                    </Card>
                  </div>
                </div>
                <CardBody>
                  <Flex vAlign='center' fluid className='w-100 mb-2 top-flex flex-sm-column'>
                    <CustomQueryFilter {...props} handleFilterUpdate={handleFilterUpdate}
                      defaultAppliedFilter={
                        type
                          ? [
                            { filter: "Instance", operator: "==", value: id },
                            {
                              filter: "ServiceType",
                              operator: "==",
                              value: type.split(",").map((i) => Number(i)),
                            },
                          ]
                          : { filter: 'Instance', operator: '==', value: id }
                      }
                      elegibleFilters={['Instance', 'Platform', 'ServiceType']} />
                    <Flex.Item push>
                      <div className='tbl-search float-right mt-sm-2 ml-sm-0 ml-md-auto ml-0'>
                        <GridGlobalSearch setSearchInput={(input) => filterGridData(input)} />
                      </div>
                    </Flex.Item>
                  </Flex>
                  <div className='w-100'>
                    {
                      isLoaded ?
                        (
                          <KendoGrid
                            style={{
                              height: "456px",
                            }}
                            pageable={{
                              buttonCount: 3
                            }}
                            sortable={true}
                            data={process(detailTable.filter(tr => {
                              if (serviceState == -1) { return true }
                              else if (serviceState != -1 && tr.Health == serviceState) { return true }
                              return false;
                            }), dataState)}
                            {...dataState}
                            onDataStateChange={(e) => {
                              setDataState(e.dataState);
                            }}
                            expandField="expanded"
                            onExpandChange={expandChange}
                          >
                            {showActionColumn ? (
<Column field="InstanceName" title="Instance" width={180} locked={true} cell={CellInstanceNALabel} />
                            ):(
<Column field="InstanceName" title="Instance" width={180} locked={true} cell={CellInstanceOverviewLabel} />
                            )}
                            
                            <Column field="ServiceDisplayName" title="Service Display Name" cell={RenderTooltipCell} locked={true} width={300} />
                            <Column field="DCName" title="Machine Name" width={150} cell={RenderTooltipCell}/>
                            <Column field="Platform" title="Platform" width={150} />
                            <Column field="LastPing" title="Last Ping" cell={CellDateTime} width={170} />
                            <Column field="Health" title="Health" cell={CellHealthStatus} width={120} />
                            {showActionColumn && (
                            <Column
                              field=""
                              title="Actions"
                              style={{ textAlign: "center" }}
                              width={100}
                              cell={ActionIconServices}
                            />
                            )}
                          </KendoGrid>
                        )
                        :
                        <Loader />
                    }
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
<Dialog
            open={dialogOpen}
            onOpen={() => setDialogOpen(true)}
            onCancel={handleAddEditClickClose}
            onConfirm={handleAddEditClickClose}
            header={editMode ? "Map Service Instance" : "Add Service"}
            headerAction={{
                      icon: <CloseIcon />,
                      title: "Close",
                      onClick: () => setDialogOpen(false),
                    }}
            style={{ width: '400px' }}
            content={
              <div class="csform" id="serviceNotMapped">
              <Form>
                <FormInput
                  name="serviceName"
                  label="Service Display Name"
                  required={true}
                  defaultValue={serviceData?.ServiceDisplayName || ''}
                  className="cspadding hideiconsnmp" readOnly={true}
                />
                <FormInput
                  name="machineName"
                  label="Machine Name"
                  required={true}
                  defaultValue={serviceData?.DCName || ''}
                   className="cspadding hideiconsnmp" readOnly={true}
                />
                <FormDropdown
                                        label={{
                                          content: `Instance*`,
                                          id: "instances-inline",
                                        }}
                                        items={instances}
                                        aria-labelledby={"instances-inline"}
                                        placeholder="Choose Instance"
                                        fluid
                                        autosize="true"
                                        value={
                                          serviceData != null && serviceData.InstanceId > -1
                                            ? {
                                                header: serviceData?.InstanceName,
                                                value: serviceData?.InstanceId,
                                              }
                                            : null
                                        }
                                        onChange={handleInstanceChange}
                                      />
                                     
                                                                 {serviceInstance == null &&
                        ( <Text
                                                                                                color="red"
                                                                                                content="*Instance Required"
                                                                                              />)}
                                                                
                 <DialogActionsBar>
                                         <button
                                           className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                           onClick={addEditSubmitClickHandler}
                                         >
                                           {" "}
                                           Submit
                                         </button>
                                         <button
                                           className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                           onClick={handleAddEditClickClose}
                                         >
                                           {" "}
                                           Close
                                         </button>
                                       </DialogActionsBar>                     
              </Form>
              </div>
              
            }
            
          />
          <FluentDialog
                    cancelButton="Cancel"
                    confirmButton="Confirm"
                    onCancel={() => {
                      setDeleteConfirmationDialog(false);
                      setDeleteServiceObj(null);
                    }}
                    onConfirm={() => removeData()}
                    open={openDeleteConfirmationDialog}
                    backdrop
                    header="Action confirmation"
                    headerAction={{
                      icon: <CloseIcon />,
                      title: "Close",
                      onClick: () => {
                        setDeleteConfirmationDialog(false);
                        setDeleteServiceObj(null);
                      },
                    }}
                    content={`Are you sure to delete Service: ${deleteServiceObj?.ServiceDisplayName}?`}
                  />
        </div>
      )}
    </WindowContext.Consumer>
  );
};

export { ServiceDetail }